import { combineReducers } from 'redux';
import { app } from './countryReducer';

const reducers = combineReducers({ app });

export { reducers };
